import {firebaseConfig} from "./firebase/environment-firebase-dev";

export const environment = {
  app_name: "Balin Mobile Dev",
  production: false,

  version: "2.4.5",
  platform_type: 1,

  mobileUrl: "https://mobile-dev.balin.app",
  desktopUrl: "https://dev.balin.app",
  communicationBaseUrl: "https://comunication-dev-2jghk7fwgq-ew.a.run.app/",
  baseUrl: "https://default-dev-10862540980.europe-west1.run.app/",
  baseUrl_nativeApp: "", // solo per app nativa prod
  communicationBaseUrl_nativeApp: "", // solo per app nativa prod
  originalUrl: new URL(window.location.href),
  firebaseConfig: firebaseConfig
};
